import {del, post, put} from "../util/http.service";

export const createLoan = loan => post("/loans", loan);

export const updateLoan = (id, loan) => put("/loans/" + id, loan);

export const addLoanInstallment = id => post("/loans/" + id + "/installments");

export const removeLastLoanInstallment = id => del("/loans/" + id + "/installments");
